<div class="col-12 px-3">
  <div class="row g-3">
    <ng-container *ngIf="!somenteVisualizar">
      <div class="col-12">
         <app-cargo-form [cargo]="cargo" [dataSet]="dataSet"></app-cargo-form>
      </div>
    </ng-container>
    <nz-divider></nz-divider>
    <div class="col-12 d-flex flex-column page-content border border-radius w-100 mb-2">
      <nz-table [nzData]="dataSet" [nzSize]="'small'" [nzFrontPagination]="false" [nzShowPagination]="false"
      (nzQueryParams)="sort($event)" [nzNoResult]="semDadosTemplate">
      <thead>
        <tr>
          <th nzColumnKey="nivelHierarquico">Nível hierárquico</th>
          <th nzColumnKey="nomeCargoReferencia" nzShowSort [nzSortFn]="true">Nome do Cargo Referência</th>
          <!-- <th nzColumnKey="cargoSubordinado.nomeCargoReferencia" nzShowSort [nzSortFn]="true">Cargo Subordinado</th> -->
          <ng-container *ngIf="!somenteVisualizar">
            <th class="text-center">Ações</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of dataSet">
          <td>{{ item?.nivelHierarquico}}</td>
           <td>{{ item?.nomeCargoReferencia}}</td>
          <!-- <td>{{ item?.cargoSubordinado?.nomeCargoReferencia}}</td> -->

          <ng-container *ngIf="!somenteVisualizar">
          <td class="text-center">
              <button nz-button type="button" nz-dropdown [nzDropdownMenu]="menu">
                <span nz-icon nzType="more" nzTheme="outline"></span>
              </button>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="editarCargoSubordinado(item)">
                    <a>Editar Subordinado</a>
                  </li>
                  <li nz-menu-item (click)="removerCargo(item)">
                    <a>Deletar</a>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </ng-container>
        </tr>
      </tbody>
    </nz-table>
    <ng-template #footerTemplate>
      <section class="d-flex justify-content-end w-100">
        <app-pagination [itemPorPagina]="10"></app-pagination>
      </section>
    </ng-template>
    <ng-template #semDadosTemplate>
      <div class="d-flex align-items-center justify-content-center" *ngIf="!dataSet?.length">
        <nz-empty [nzNotFoundContent]="'Nenhum registro encontrado'"></nz-empty>
      </div>
    </ng-template>
    </div>
  </div>
</div>
